import React, { Suspense, lazy, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Loader from './components/common/Loader';
import './styles/main.scss';
const Status = lazy(() => import('./components/status/status'));
const BookingStatus = lazy(() => import('./components/status/booking/BookingStatus'));
const BookingDetails = lazy(() => import('./components/status/booking/BookingDetails'));
const PaymentDetails = lazy(() => import('./components/status/payment/paymentDetails'));

function App() {
  return (
    <Router >
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/booking-enquiry" element={<Status />} />
            <Route path="/booking-enquiry/bus_pnr_enquiry" element={<BookingStatus type="bus_pnr_enquiry"/>} />
            <Route path="/booking-enquiry/order_id" element={<BookingStatus type="order_id"/>} />
            <Route path="/booking-enquiry/mobile_based_enquiry" element={<BookingStatus type="mobile_based_enquiry"/>} />
            <Route path="/booking-enquiry/email_based_enquiry" element={<BookingStatus type="email_based_enquiry"/>} />
            <Route path="/booking-enquiry/booking/:id" element={<BookingDetails />} />
            <Route path="/booking-enquiry/payment/:id" element={<PaymentDetails />} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </Router>
  );
}

class ErrorBoundary extends React.Component {
  constructor() {
    super();
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }

    return this.props.children;
  }
}

const ErrorPage = () => (
  <div className='err-screen'>
    Oops! some error occured!
    <br />
    <br />
    <a href='/' target='_self'>GO TO HOME</a>
  </div>
)

export default App;
